(function () {
  var SELECTOR = '.faq-themen';

  function initSection(root) {
    if (!root || root.dataset.faqInit === 'true') return;
    root.dataset.faqInit = 'true';

    var items = Array.prototype.slice.call(root.querySelectorAll('.faq-themen__item'));
    var links = Array.prototype.slice.call(root.querySelectorAll('[data-faq-navlink]'));
    var cats = Array.prototype.slice.call(root.querySelectorAll('[data-faq-cat]'));
    var list = root.querySelector('.faq-themen__navlist');

    // Immer nur eine Frage gleichzeitig offen
    if (root.dataset.singleOpen === 'true') {
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other !== item && other.open) other.open = false;
          });
        });
      });
    }

    if (!links.length || !cats.length) return;

    function offset() {
      var raw = window.innerWidth <= 900 ? root.dataset.offsetMobile : root.dataset.offsetDesktop;
      return parseInt(raw, 10) || 0;
    }

    function setActive(id) {
      links.forEach(function (link) {
        var on = link.getAttribute('data-faq-navlink') === id;
        link.classList.toggle('is-active', on);
        if (on) {
          link.setAttribute('aria-current', 'true');
          // Aktives Thema auf Mobil in die Pill-Leiste scrollen
          if (list && list.scrollWidth > list.clientWidth + 4) {
            var left = Math.max(link.offsetLeft - 16, 0);
            if (list.scrollTo) {
              list.scrollTo({ left: left, behavior: 'smooth' });
            } else {
              list.scrollLeft = left;
            }
          }
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }

    // Scrollspy: markiert das Thema, das gerade oben steht
    var ticking = false;
    function update() {
      ticking = false;
      var line = offset() + 24;
      var current = cats[0];
      cats.forEach(function (cat) {
        if (cat.getBoundingClientRect().top <= line) current = cat;
      });
      setActive(current.getAttribute('data-faq-cat'));
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();

    // Sanftes Springen mit Abstand zum Sticky-Header
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var id = link.getAttribute('data-faq-navlink');
        var target = root.querySelector('[data-faq-cat="' + id + '"]');
        if (!target) return;
        event.preventDefault();
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset();
        window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
        setActive(id);
        if (history.replaceState) history.replaceState(null, '', '#' + id);
      });
    });
  
    // Nach dem Aufklappen die Frage sichtbar halten
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        setTimeout(function () {
          var top = item.getBoundingClientRect().top;
          var min = offset() + 12;
          if (top < min) {
            var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            window.scrollTo({
              top: item.getBoundingClientRect().top + window.pageYOffset - min,
              behavior: reduce ? 'auto' : 'smooth'
            });
          }
        }, 60);
      });
    });
  }
  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll(SELECTOR), initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector(SELECTOR);
    if (root) initSection(root);
  });
})();